/**
 * CRM Module - Role Constants
 *
 * Определяет роли модуля CRM.
 * Используется для типизации, проверок прав и сидов.
 */

export const CRM_ROLES = {
  CRM_SALESPERSON: 'CRM_SALESPERSON',
  CRM_OWNER: 'CRM_OWNER',
  CRM_INTERN: 'CRM_INTERN',
  CRM_BRANCH_MANAGER: 'CRM_BRANCH_MANAGER',
  /**
   * Старший менеджер лидов. Полный доступ к CRM + право архивировать лиды
   * (середина между обычным салеспёрсоном без права архива и руководителем
   * филиала).
   */
  CRM_LEAD_MANAGER: 'CRM_LEAD_MANAGER',
} as const;

/**
 * Определения ролей для сидов и UI
 */
export const CRM_ROLE_DEFS = [
  {
    role_code: CRM_ROLES.CRM_SALESPERSON,
    name: 'crm_salesperson',
    description: 'CRM Salesperson - Full access to CRM module',
    is_active: true,
  },
  {
    role_code: CRM_ROLES.CRM_OWNER,
    name: 'crm_owner',
    description: 'CRM Owner - Full access to CRM module',
    is_active: true,
  },
  {
    role_code: CRM_ROLES.CRM_INTERN,
    name: 'crm_intern',
    description: 'CRM Intern - Read-only access to CRM module (no update/delete)',
    is_active: true,
  },
  {
    role_code: CRM_ROLES.CRM_BRANCH_MANAGER,
    name: 'crm_branch_manager',
    description: 'CRM Branch Manager - Full CRM access + partner delete/archive',
    is_active: true,
  },
  {
    role_code: CRM_ROLES.CRM_LEAD_MANAGER,
    name: 'crm_lead_manager',
    description: 'CRM Lead Manager - Full CRM access + lead archive',
    is_active: true,
  },
] as const;

/**
 * TypeScript тип для ролей CRM
 */
export type CrmRole = (typeof CRM_ROLES)[keyof typeof CRM_ROLES];
